
export class SoundConstants
{
    public static MUSIC: string = "music";
    public static MENU_MUSIC: string = "menu_loop";
    public static BUTTON_CLICK: string = "button";
    public static BUTTON_DISABLED: string = "button_disabled";
    public static GAME_END: string = "game_end";
    public static KYKKA_HIT: string = "kykka_hit";
}

